<aside class="sidebar d-flex flex-column justify-content-between">
    <div>
        <a [routerLink]="['/intro']"><img [src]="'./assets/img/logo-corto.png'" alt="" class="sidebar__logo"></a>
        <nav>
            <ul class="sidebar__navigation">
                <li class="sidebar__navigation-item" routerLinkActive="is-active">
                    <a [routerLink]="['/services']" class="sidebar__navigation-link">
                        <i class="far fa-handshake"></i>
                        <span class="sidebar__navigation-title">Services</span>
                    </a>
                </li>

                <li class="sidebar__navigation-item" routerLinkActive="is-active">
                    <a [routerLink]="['/flows/requirements']" class="sidebar__navigation-link">
                        <i class="far fa-object-ungroup"></i>
                        <span class="sidebar__navigation-title">Flows</span>
                    </a>
                </li>

                <li class="sidebar__navigation-item" routerLinkActive="is-active">
                    <a [routerLink]="['/activities']" class="sidebar__navigation-link">
                        <i class="far fa-list-alt"></i>
                        <span class="sidebar__navigation-title">Activities</span>
                    </a>
                </li>

                <li class="sidebar__navigation-item" routerLinkActive="is-active">
                    <a [routerLink]="['/documents']" class="sidebar__navigation-link">
                        <i class="far fa-file-alt"></i>
                        <span class="sidebar__navigation-title">Docs</span>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</aside>